<script>
    // import Redis from 'ioredis'
    import Pagination from './Pagination.svelte'
    import Table from './Table.svelte'

    const host = window.location.hostname
    export let swp = {
        'ajax_url': '//'+host+'/wp-admin/admin-ajax.php',
    }

    const container = document.getElementById('mightybytes-find-a-realtor-app');
    if(!container) {
        throw new Error()
    }
    export let realtors = []
    export let total_realtors = 0
    export let total_pages = 1
    export let pagination_limit = 8
    export let order_by = 'last_name asc'

    let per_page = 500
    let current_page = 1
    let search_query = ''
    
    // The fetch promise. This format svelte will wait to render the component until the promise is resolved.
    const get_all_agents_paginated = async () => {
        realtors = []
        const bodystring = 'action=get_all_agents_paginated&perPage='+per_page+'&currPage='+current_page+'&orderBy='+order_by+'&query='+search_query
        
        return fetch( swp.ajax_url, {
            method: "POST",
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            credentials: 'same-origin',
            body: bodystring
        })
        .then(res => {
            if(!res.ok) {
                throw new Error()
            }

            return res.json()
        })
        .then(res => {
            console.log("results", res)
            realtors = res['query_results']
            total_realtors = res['total_rows']
            console.log("totals", total_realtors, per_page)
            total_pages = Math.ceil(total_realtors / per_page)
            // console.log("total pages", total_page, total_realtors, per_page                     )
            
            pagination_limit = (total_pages >= 8) ? 8 : total_pages
            document.querySelector('.pagination').classList.add('active')
            return realtors
        })
    }

    const pagechecker = () => {
        console.log("pagination thinks current page is", current_page)
    }

    // When user changes query settings. Will have sort and search too.
    const updatePage = () => {
        per_page = document.getElementById('selectPerPage').value
        if(per_page > 2000) {
            alert("Sorry. You can only view up to 2,000 results per page.")
            per_page = 1000
        } else if (per_page < 10) {
            alert("Sorry. You need to allow at least 10 results per page.")
            per_page = 10
        }
        current_page = 1
        promise = get_all_agents_paginated()
    }

    const navigate_prev = () => {
        if(current_page > 1) {
            current_page = current_page - 1
            pagechecker()
            promise = get_all_agents_paginated()
        }
    }

    const navigate_next = () => {
        if(current_page < total_pages) {
            current_page = current_page + 1
            pagechecker()
            promise = get_all_agents_paginated()
        }
    }

    const navigate_page = (page) => {
        current_page = page
        pagechecker()
        promise = get_all_agents_paginated()
    }
    
    // We wait for promise then pass the realtors[] to the component below using the {#each} syntax
    let promise = get_all_agents_paginated()

    // Some agents put their name in all caps. 
    String.prototype.toProperCase = function () {
        return this.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
    };

    // Make my numbers look pretty
    const formatNumber = new Intl.NumberFormat('en-US').format

    const setOrderBy = (e) => {
        const current_order = e.target.classList
        current_page = 1
        console.log('order', current_order)
        const field = current_order[0]
        const direction = (current_order[1] == 'asc') ? 'desc' : 'asc'
        order_by = field + ' ' + direction
        e.currentTarget.classList.replace(current_order[1], direction)
        document.querySelector('#realtors th button').classList.remove('active')
        e.currentTarget.classList.add('active')

        console.log("order by", order_by)
        promise = get_all_agents_paginated()
        
    }
</script>


<div class="table-options">
    
    <div class="row">
        <div class="col">
            <label for="search" class="sr-only">Search</label> <input type="search" id="search" placeholder="Search" bind:value={ search_query }/>
            <button class="btn btn-primary" on:click={ ()=> updatePage()  }>Search</button>
        </div>
        <div class="col text-center">
            { total_pages ? formatNumber(total_realtors) : 'Loading ' } Results | Page { current_page } of { total_pages ?  total_pages : '' }
        </div>
        <div class="col">
            View <input type="number" id="selectPerPage" min="10" max="2000" bind:value={ per_page } /> Per Page <button class="apply-btn" on:click={ ()=> updatePage() }>Apply</button>
        </div>
    </div>

    <Pagination { current_page } { total_pages } { navigate_prev } { navigate_next } { navigate_page } { per_page } { pagination_limit } />
   
    <Table { realtors } { setOrderBy } { order_by } { promise }/>
    
    <div class="bottom-pagination">
        <br>
        Page { current_page } of { total_pages ?  total_pages : '1' }
    </div>
    
    
</div>

<style>
    .table-options {
        margin: 0 auto;
        font-size: .82em;
    }
    .table-options .row .col {
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: .5rem;
    }
    .table-options .row .col:last-child {
        justify-content: flex-end;
    }
    .table-options .apply-btn {
        margin-left: .5em;
        font-size: .86em;
    }
    .table-options input[type="search"], .table-options input[type="number"] {
        padding: .5em;
        border: solid 1px #ccc;
        border-radius: 2px;
        margin: 0 .5em;
    }
    .bottom-pagination {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        margin: .4em 0 .8em;
        font-size: .86em;
    }
    .text-center {
        text-align: center;
        justify-content: center;
    }
    .sr-only {
        border: 0 !important;
        clip: rect(1px, 1px, 1px, 1px) !important; /* 1 */
        -webkit-clip-path: inset(50%) !important;
            clip-path: inset(50%) !important;  /* 2 */
        height: 1px !important;
        margin: -1px !important;
        overflow: hidden !important;
        padding: 0 !important;
        position: absolute !important;
        width: 1px !important;
        white-space: nowrap !important;            /* 3 */
    }
    .sr-only-focusable:focus,
    .sr-only-focusable:active {
        clip: auto !important;
        -webkit-clip-path: none !important;
            clip-path: none !important;
        height: auto !important;
        margin: auto !important;
        overflow: visible !important;
        width: auto !important;
        white-space: normal !important;
    }
    @media(max-width: 921px) {
        .table-options input[type="search"] {
            width: 100%;
            margin-left: 0;
        }
        .table-options .row {
            flex-direction: column;
        }
        .table-options .row .col:first-child {
            padding: 0;
        }
        .table-options .row .col:last-child {
            padding: 0;
            justify-content: center;
        }
    }
</style>